import { FOIRequestResponse } from '@interfaces/FOIRequest.interface';
import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { foiRequest } from '../FOIRequest';

export function useSubmitFOIRequest() {
  return useMutation<FOIRequestResponse, AxiosError, FormData>(async (requestData: FormData) => {
    const { data: authData } = await foiRequest.getAccessToken();
    const { data } = await foiRequest.submitFOIRequest(requestData, authData.access_token);
    return data;
  });
}
